import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function InventoryManufacturedMaterialViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState({ data: [] });
  const [subRowDetails, setSubRowDetails] = useState({});
  const [loadingRows, setLoadingRows] = useState({}); // { [rowId]: boolean }
  

  const getInStockRawMaterial = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(
      "inventoryManufacturedMaterial",
      payload,
    );

    if (callResult.success) {
      setProducts(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setLoading(false);
  };

  const onManufacturedInventoryAdjusted = async function (
    rowData,
    rowIndex,
    newAmount,
  ) {
    const payload = {
      lot_number: rowData.lot_number,
      newAmount: newAmount,
      oldAmount: rowData.total_individual_units,
    };
    let callResult = await makePostApiCall(
      "manufacturedInventoryAdjusted",
      payload,
    );

    if (callResult.success) {
      if (newAmount == 0) {
        const filteredProducts = products.data.filter(
          (element) => element.lot_number !== rowData.lot_number,
        );
        setProducts({ ...products, data: filteredProducts });
      }
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const fetchSubRowDetails = async function (rowData, currentSearchValue) {
    const payload = {
      product_id: rowData.product_id,
      search_value: currentSearchValue,
    };

    setLoadingRows((prev) => ({ ...prev, [rowData.id+currentSearchValue]: true }));

    let callResult = await makePostApiCall(
      "inventoryManufacturedSubItem",
      payload,
    );

    if (callResult.success) {
     
      setSubRowDetails((prev) => ({ ...prev, [rowData.id+currentSearchValue]: callResult.data }));

      setLoadingRows((prev) => ({ ...prev, [rowData.id+currentSearchValue]: false }));
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  }

  const onManufacturedInventoryAdjustedByLot = async function (
    rowData,
    rowIndex,
    newAmount,
  ) {
    const payload = {
      lot_number: rowData.lot_number,
      newAmount: newAmount,
      oldAmount: rowData.total_individual_units,
    };
    let callResult = await makePostApiCall(
      "manufacturedInventoryAdjustByLot",
      payload,
    );

    if (callResult.success) {
      getInStockRawMaterial(null, null);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const exportNetsuiteInventoryAdjustmentCsv = async function () {
    let callResult = await makePostApiCall(
      `exportNetsuiteInventoryAdjustmentCsv`,
    );
    if (callResult.success) {
      window.open(callResult.data.location, "_blank").focus();
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    getInStockRawMaterial,
    loading,
    products,
    onManufacturedInventoryAdjusted,
    onManufacturedInventoryAdjustedByLot,
    showErrorModal,
    emptyModal,
    setEmptyModelOpen,
    exportNetsuiteInventoryAdjustmentCsv,
    fetchSubRowDetails,
    loadingRows,
    subRowDetails,
  };
}
